<form *ngIf="formData$ | async; let formData; else loading" [formGroup]="formData.form" (ngSubmit)="onSubmit()">
  <ub-card [rounded]="true">
    <h4 class="t-weight--normal" title i18n>Filter by</h4>
    <div content>
      <p>
        <app-form-fields [formData]="formData"></app-form-fields>
      </p>
    </div>
    <div footer>
      <ub-button-list>
        <button mat-flat-button color="primary" type="submit" [disabled]="formData.submitting || formData.invalid">{{
          formData.options.submitTitle ?? getDefaultSubmitButtonTitle() }}</button>
        <button mat-flat-button color="accent" type="button" (click)="reset()" i18n>Reset to default</button>
      </ub-button-list>
    </div>
  </ub-card>
</form>
<ng-template #loading>
  <div i18n>Loading ...</div>
</ng-template>
